import { render, staticRenderFns } from "./DescriptionTable.vue?vue&type=template&id=24b36d1c&scoped=true&"
import script from "./DescriptionTable.vue?vue&type=script&lang=js&"
export * from "./DescriptionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b36d1c",
  null
  
)

export default component.exports